import type { AxiosRequestConfig, AxiosResponse } from 'axios';
import axios from 'axios';

import type { IDaDataRequest, IDaDataResponse } from '../models';

const HEADERS = {
    Authorization: process.env.ALFALEASING_DADATA_AUTH,
};
const HOST = process.env.ALFALEASING_DADATA_HOST;
const URL = `${HOST}/suggest/party`;

export const getCompaniesSuggestions = async (payload: IDaDataRequest) => {
    const request: AxiosRequestConfig = {
        method: 'POST',
        url: URL,
        headers: HEADERS,
        data: payload,
    };

    const { data }: AxiosResponse<IDaDataResponse> = await axios(request);

    return data;
};
